export default {
      id: "ic-misc-time-usage",
      viewBox: "0 0 60 60",
      url: "../dist/images/" + "sprite.svg#ic-misc-time-usage",
      toString: function () {
        return this.url;
      }
    }